import React from "react";
import PaySlip from "./PaySlip/PaySlip";

const PayRoll = () => {
  return (
    <>
      {/* <div>PayRoll</div> */}
      {/* <PaySlip /> */}
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src="https://payroll-gray.vercel.app"
          title="External Site"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        ></iframe>
      </div>
    </>
  );
};

export default PayRoll;
